import { testimonials } from "@/mocks/anime";

const pillars = [
  {
    icon: "ri-heart-3-line",
    title: "缘分匹配",
    desc: "读懂你的口味与心情，把「下一部对电波的番」亲自送到你面前，不让你再做无用功。",
  },
  {
    icon: "ri-gift-2-line",
    title: "盲盒番剧",
    desc: "口碑把关的未知惊喜，把「选番」变成拆礼物般的快乐仪式，开盒即沉浸。",
  },
  {
    icon: "ri-compass-3-line",
    title: "随缘漫游",
    desc: "彻底告别选择困难，把方向交给命运，让每一次刷新都成为一场新的小冒险。",
  },
];

export default function About() {
  return (
    <section id="about" className="relative py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center mb-14 md:mb-20">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-semibold px-4 py-1.5 mb-4">
              <i className="ri-sparkling-2-line"></i>
              关于我们
            </p>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-snug">
              别再做选择题，
              <br />
              让缘分替你按下播放键
            </h2>
            <p className="mt-4 md:mt-6 text-foreground-700 text-sm md:text-base leading-relaxed">
              小缘动漫库诞生于一个很朴素的烦恼：好看的番那么多，可翻到深夜也点不下手。所以我们决定，把「选番」这件事变得轻松又有趣。
            </p>
            <p className="mt-3 text-foreground-700 text-sm md:text-base leading-relaxed">
              我们坚持内容与口碑并重，只收录值得一看的优质作品。无论你是老观众还是新入坑，小缘都希望用缘分、惊喜与漫游这三种方式，帮你更快乐地拥抱每一个好故事。
            </p>
            <a
              href="#fate"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#fate")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-semibold px-7 py-3 transition-colors cursor-pointer whitespace-nowrap"
            >
              来测今日缘分
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="space-y-4">
            {pillars.map((p, i) => (
              <div
                key={p.title}
                className="flex items-start gap-4 rounded-2xl bg-background-100 border border-background-200/70 p-5 md:p-6"
              >
                <span className="mt-0.5 w-11 h-11 shrink-0 flex items-center justify-center rounded-xl bg-accent-500 text-background-50 text-xl">
                  <i className={p.icon}></i>
                </span>
                <div>
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-bold text-accent-700">{String(i + 1).padStart(2, "0")}</span>
                    <h3 className="font-heading text-lg md:text-xl text-foreground-950">{p.title}</h3>
                  </div>
                  <p className="mt-1.5 text-sm text-foreground-700 leading-relaxed">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 用户口碑 */}
        <div>
          <div className="text-center max-w-2xl mx-auto mb-8 md:mb-12">
            <h3 className="font-heading text-2xl md:text-3xl text-foreground-950">来自观众的口碑</h3>
            <p className="mt-3 text-foreground-700 text-sm md:text-base">
              每一次「对上电波」的瞬间，都是我们继续做下去的理由。
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="rounded-2xl bg-background-100 border border-background-200/70 p-6 md:p-7"
              >
                <div className="flex gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-4 text-sm text-foreground-700 leading-relaxed">
                  “{t.content}”
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-heading">
                    {t.name.charAt(0)}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-600">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}